module.exports = __webpack_public_path__ + "packs/media/images/MM_Slider_5a-e8c13259297bcde2eede198b1d143f8d.jpg";